import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../context/LangContext";

export default function RinseRepeat() {
  const { c } = useLang();
  const r = c.rinse;
  return (
    <section id="scale" className="section">
      <div className="container-x">
        <div className="reveal" style={{ maxWidth: 720, marginBottom: "3.5rem" }}>
          <span className="eyebrow">{r.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0 1.6rem" }}>
            {r.title.pre}<span className="italic-gold">{r.title.em}</span>{r.title.post}
          </h2>
          <p className="body-text">{r.para}</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: "1.5rem", marginBottom: "3.5rem" }}>
          {r.steps.map((st, i) => (
            <div key={i} className="card reveal" style={{ padding: "2rem", position: "relative" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.8rem", marginBottom: "1.2rem" }}>
                <span className="font-serif" style={{ fontSize: "1.6rem", color: "var(--gold)" }}>0{i + 1}</span>
                {i < r.steps.length - 1 && <span style={{ color: "var(--gold)", opacity: 0.4 }}><ArrowRight size={18} /></span>}
              </div>
              <h3 className="font-serif" style={{ fontSize: "1.3rem", marginBottom: "0.8rem" }}>{st.t}</h3>
              <p className="body-text" style={{ fontSize: "0.9rem" }}>{st.d}</p>
            </div>
          ))}
        </div>

        <div className="card reveal" style={{ padding: "2.5rem", textAlign: "center", background: "linear-gradient(180deg, rgba(201,162,75,0.06), transparent)" }}>
          <h3 className="font-serif" style={{ fontSize: "1.8rem", marginBottom: "0.8rem" }}>{r.ctaTitle}</h3>
          <p className="body-text" style={{ marginBottom: "1.8rem" }}>{r.ctaPara}</p>
          <a href="#calculator" className="btn-gold">{r.ctaBtn} <ArrowRight size={15} /></a>
        </div>
      </div>
    </section>
  );
}
